<template>
  <mia-form @submit="save">
    <mia-form-section title="VTI Rückgabe">
      <template #description>
        <mia-required-field-notice />
      </template>

      <mia-notice
        v-if="car.item_vti_status === 'pending'"
        type="error"
        permanent
      >
        Dieses Fahrzeug befindet sich bereits im Status <b>VTI zurückgenommen</b>.
      </mia-notice>
      <mia-notice
        v-else-if="car.item_vti_status === 'completed'"
        type="error"
        permanent
      >
        Dieses Fahrzeug befindet sich bereits im Status <b>VTI abgeholt</b>.
      </mia-notice>
      <mia-form-section-grid v-else>
        <!-- Stock Number -->
        <mia-feature-select
          v-model="form.stockNumber"
          label="Lagerplatz"
          :errors="getErrors('item_stock_number')"
          required
          @input="clearErrors('item_stock_number')"
        >
          <template #options>
            <option
              value="0"
              disabled
            >
              Ohne Lagerplatz
            </option>
            <optgroup
              v-for="(slots, location) in stockSlots"
              :key="location"
              :label="location"
            >
              <option
                v-for="slot in slots"
                :key="slot.id"
                :value="slot.id"
                v-text="slot.title"
              />
            </optgroup>
          </template>
        </mia-feature-select>

        <!-- Assignee -->
        <mia-feature-select
          v-model="form.assignee"
          label="Zuständig"
          :errors="getErrors('item_assignee')"
          required
          @input="clearErrors('item_assignee')"
        >
          <template #options>
            <option value="">
              Zuständigkeit auswählen
            </option>
            <option
              v-for="employee in employees"
              :key="employee.id"
              :value="employee.id"
              :selected="employee.id === form.assignee"
            >
              {{ employee.full_name }}
            </option>
          </template>
        </mia-feature-select>
      </mia-form-section-grid>
    </mia-form-section>

    <template #actions>
      <mia-submit-button
        :disabled="$wait.any || ['pending', 'completed'].includes(car.item_vti_status)"
        :is-loading="$wait.is('saving vti return')"
        label="VTI zurücknehmen"
      />
    </template>
  </mia-form>
</template>

<script>
import get from 'lodash/get'
import { getStockSlots, returnVti } from '@/api/cars'
import { getEmployees } from '@/api/dealer'
import FormSectionGrid from '@/components/ui/widgets/FormSectionGrid.vue'
import FormSection from '@/components/ui/widgets/FormSection.vue'
import Form from '@/components/ui/widgets/Form.vue'
import RequiredFieldNotice from '@/components/cars/edit/forms/RequiredFieldNotice.vue'
import HandlesBackendValidationErrors from '@/mixins/HandlesBackendValidationErrors'
import SubmitButton from '@/components/cars/edit/SubmitButton.vue'
import { getCar } from '@/api/car'
import FeatureSelect from '@/components/cars/edit/FeatureSelect.vue'
import Notice from '@/components/cars/edit/Notice.vue'

export default {
  name: 'MiaCarVtiReturnForm',

  components: {
    'mia-form': Form,
    'mia-form-section': FormSection,
    'mia-form-section-grid': FormSectionGrid,
    'mia-required-field-notice': RequiredFieldNotice,
    'mia-submit-button': SubmitButton,
    'mia-feature-select': FeatureSelect,
    'mia-notice': Notice
  },

  mixins: [HandlesBackendValidationErrors],

  data() {
    return {
      stockSlots: {},
      employees: [],
      form: {
        stockNumber: '0',
        assignee: ''
      }
    }
  },

  computed: {
    car: {
      get() {
        return this.$store.state.car.car
      },

      set(car) {
        this.$store.commit('setCar', car)
      }
    }
  },

  watch: {
    car: {
      immediate: true,
      deep: true,
      handler(car) {
        this.form.stockNumber = get(car, 'item_stock_slot.id', '0')
        this.form.assignee = parseInt(this.car.item_assignee, 10)
      }
    }
  },

  async created() {
    this.stockSlots = await getStockSlots(this.car.id)
    this.employees = await getEmployees()
  },

  methods: {
    async save() {
      this.resetErrors()
      this.$wait.start('saving vti return')

      const [error] = await returnVti(this.car.id, {
        item_stock_number: this.form.stockNumber,
        item_assignee: this.form.assignee
      })

      this.$wait.end('saving vti return')

      if (!error) {
        this.car = await getCar({
          carId: this.car.id
        })

        window.eventBus.$emit('mia-info', {
          info: ['VTI erfolgreich zurückgenommen.']
        })
      } else {
        this.handleBackendValidationErrors(error)

        window.eventBus.$emit('mia-error', {
          error: ['Fehler beim Speichern der Daten.']
        })
      }
    }
  }
}
</script>
